import { Button } from '@acpaas-ui/react-components';
import AttachmentsList from '../components/attachments/AttachmentsList';
import TextArea from '../components/forms/TextArea';
import TextField from '../components/forms/TextField';
import { useResourceInput } from '../hooks/useResourceInput';
import responseValidators from '../services/response.validators';
import Modal from './Modal';
import ModalTitle from './ModalTitle';
import formValidators from '../form-validators';

const AttachmentDetailsModal = ({
  isOpen,
  onClose,
  onDelete,
  form,
  onUpdate,
  onUpdateSuccess,
  dossierId,
  inlineEdit,
  descriptionLabel = 'Beschrijving',
  descriptionDescription = '',
  write = true,
  read = true
}) => {
  const { data, reset, error, isSubmitting, submitStart, submitOk, submitError, input } = form;
  const resource = {
    isFetching: !isOpen,
    isSubmitting,
    getValue: (field) => data?.[field],
    setValue: (value, field, options) => {
      submitStart();
      if (inlineEdit) {
        onUpdate(data?.id, { [field]: value });
        submitOk();
        input(value, field);
        options?.onSuccess && options.onSuccess();
      } else {
        onUpdate(data?.id, { [field]: value })
          .then((resp) => {
            responseValidators.updateForDossier(resp);
            input(value, field);
            submitOk();
            onUpdateSuccess();
            options?.onSuccess && options.onSuccess();
          })
          .catch((err) => {
            submitError({ [field]: err.message });
            options?.onError && options.onError();
          });
      }
    },
    onCancel: reset,
    validators: { url: (value) => formValidators.required(value) || formValidators.attachmentUrl(value) }
  };

  const handleClose = () => {
    if (isSubmitting) {
      return;
    }

    reset();
    onClose && onClose();
  };

  const nameInput = useResourceInput('name', resource);
  const urlInput = useResourceInput('url', resource);
  const descriptionInput = useResourceInput('description', resource);

  if (!read) {
    return null;
  }

  return (
    <Modal
      className="spo-o-attachment-details-modal"
      title={<ModalTitle hasError={!!error} title="Details bestand of URL" />}
      isOpen={isOpen}
      onClose={handleClose}
      isSubmitting={isSubmitting}
      disableCancel
      disableConfirm
      extraFooterActions={
        write &&
        onDelete && (
          <Button type="danger" outline onClick={() => onDelete(data)}>
            Verwijderen
          </Button>
        )
      }
    >
      <div className="row">
        <div className="col-xs-12 col-md-6 u-margin-bottom">
          <TextField
            label="Titel van bestand of URL"
            {...nameInput}
            readOnly={!write}
            hasError={!!error?.name}
            description={error?.name ?? ''}
          />
        </div>
        {data.url && (
          <div className="col-xs-12 col-md-6 u-margin-bottom">
            <TextField
              label="URL (https://digipolis.sharepoint.com/...)"
              {...urlInput}
              readOnly={!write}
              hasError={!!error?.url}
              description={error?.url ?? ''}
            />
          </div>
        )}
      </div>
      <div className="row u-margin-bottom">
        <div className="col-xs-12">
          <TextArea
            label={descriptionLabel}
            readOnly={!write}
            description={descriptionDescription}
            {...descriptionInput}
          />
        </div>
      </div>
      <div className="u-margin-bottom">
        <AttachmentsList
          dossierId={dossierId}
          asDownloadLink
          labelOnly={inlineEdit}
          attachments={
            isOpen
              ? [
                  {
                    id: data?.id,
                    fileName: data?.fileName,
                    name: data?.url ? data?.name : data?.fileName ?? data?.name ?? '',
                    url: data?.url ?? ''
                  }
                ]
              : []
          }
        />
      </div>
    </Modal>
  );
};

export default AttachmentDetailsModal;
